export class ApiClient {
  private static token: string | null = localStorage.getItem('apporteur_token');

  public static setToken(token: string | null): void {
    ApiClient.token = token;
    if (token) {
      localStorage.setItem('apporteur_token', token);
    } else {
      localStorage.removeItem('apporteur_token');
    }
  }

  public static getToken(): string | null {
    return ApiClient.token;
  }

  public static async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const headers = new Headers(options.headers || {});
    headers.set('Content-Type', 'application/json');

    if (ApiClient.token) {
      headers.set('Authorization', `Bearer ${ApiClient.token}`);
    }

    const response = await fetch(endpoint, {
      ...options,
      headers
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(data.error || `Erreur serveur (${response.status})`);
    }

    return data as T;
  }
}
